module.exports = __webpack_public_path__ + "static/media/leave.42b37181.svg";